
@if (!!survey) {
  <div class="content-container">
    <h1>{{ survey['title' + crtLang.toUpperCase()] }}</h1>
    <h6>{{ survey.publicationDate | date }}</h6>
    <div class="btn-bar">
      <button class="btn btn-link me-auto" [appHasAnyPermission]="[PermissionKeys.gestionCommunication]"
              [routerLink]="['../manage', survey.id]">
        <fa-icon class="me-2" [icon]="icons.pen"></fa-icon>
        <span translate="common.manageInfo"></span>
      </button>
      <div class="right-bar">
        <button class="btn btn-outline-secondary"
          (click)="back()"
          translate="common.back">
        </button>
        @if (survey.surveyState === InformationState.Ongoing) {
          <button class="btn btn-primary"
            (click)="openSurvey()"
            translate="communicationChannel.survey.participate">
          </button>
        }
      </div>
    </div>
    <!-- Content -->
    <div class="row">
      <div class="col-12 col-lg-6">
        <div class="no-border-radius area-link"
          [innerHTML]="survey['description'  + crtLang.toUpperCase()] | urlTextToLink">
        </div>
      </div>
      @if (!!survey.resultIllustrationUrl) {
        <div class="col-12 col-lg-6">
          <div class="text-center">
            <a href="{{ survey.resultIllustrationUrl }}" target="_blank" rel="noopener">
              <img class="rounded mw-100" [src]="survey.resultIllustrationUrl"
                alt="{{ 'communicationChannel.information.illustration' | translate }}"/>
              </a>
            </div>
          </div>
        }
      </div>
      <!-- Results -->
      @if (survey.resultState === InformationState.Ongoing) {
        <h5 class="mt-4">{{ 'communicationChannel.survey.resultsTitle' | translate }}</h5>
        @if (!!survey.resultsPublicationDate) {
          <h6>{{ survey.resultsPublicationDate | date }}</h6>
        }
        <div class="row">
          <div class="col-12 col-lg-6">
            <div class="no-border-radius area-link"
              [innerHTML]="survey['resultContent'  + crtLang.toUpperCase()] ?? '' | urlTextToLink">
            </div>
          </div>
        </div>
      }
    </div>
  }

  @if (!!survey) {
    <app-document-view #documentListComponent
      [documentManagementType]="DocumentManagementTypeEnum.Survey"
      [canManage]="canManage"
    [id]="survey.id"></app-document-view>
  }
